import { render, staticRenderFns } from "./VehicleStats.vue?vue&type=template&id=318da346&scoped=true"
import script from "./VehicleStats.vue?vue&type=script&lang=js"
export * from "./VehicleStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318da346",
  null
  
)

export default component.exports